Application.Signature.Output = {
    ui: {
        container: '.step-output',
        form: '.step-output form',
        options: '.step-output .el-selectable-box input',
        submit: '.step-output .step-preview__submit',
        signature: {
            content: '.preview__content_signature',
            container: '.preview__content_signature .preview__signature-container',
            signature: '.preview__content_signature .email-signature'
        }
    },
    ready: function () {

        var self = this;

        if (!$(this.ui.container).length){
            return;
        }

        // events
        $(this.ui.options).on('change', function (e) {
            self.update();
        });
        $(this.ui.form).on('submit', function (e) {
            if (!self.isOptionChecked()){
                e.preventDefault();
            }
        });

        // init
        this.update();
        this.rescale();

        // mark as ready
        $(this.ui.container).removeClass('step-preview_loading');

    },
    update: function(){

        $(this.ui.submit).toggleClass('btn_disabled', !this.isOptionChecked());

    },
    isOptionChecked: function () {

        var noOptionChecked = true;
        $(this.ui.options).each(function () {
            if ($(this).is(':checked')){
                noOptionChecked = false;
                return false;
            }
        });

        return !noOptionChecked;

    },
    rescale: function(){

        var paddingX = 15;
        var previewWidth = $(this.ui.signature.content).outerWidth() - 2 * paddingX;
        var signatureWidth = $(this.ui.signature.signature).outerWidth();
        var paddingY = 50;
        var previewHeight = $(this.ui.signature.content).outerHeight() - 2 * paddingY;
        var signatureHeight = $(this.ui.signature.signature).outerHeight();

        var ratioX = previewWidth < signatureWidth ? previewWidth / signatureWidth : 1;
        var ratioY = previewHeight < signatureHeight ? previewHeight / signatureHeight : 1;
        var ratio = ratioX > ratioY ? ratioY : ratioX;
        $(this.ui.signature.container).css('transform', 'translate(-50%, -50%) scale(' + ratio + ')');

    }
};